import _ from 'lodash'

import http from './http'

const TIMEOUT = '500'

const url = params => {
  const { resource, path, user } = params
  return `/draft/${resource}/${path}/${user}`
}

const get = params => http.getRequest(url(params))

const put = _.debounce(
  (params, resolve, reject) =>
    http
      .putRequest(url(params), _.pick(params, [ 'data' ]))
      .then(resolve)
      .catch(reject),
  TIMEOUT
)

const set = params =>
  new Promise((resolve, reject) => put(params, resolve, reject))

const remove = async (params) => http.deleteRequest(url(params))

const setUndebounced = async params =>
  http.putRequest(url(params), _.pick(params, [ 'data' ]))

export default {
  get,
  set,
  setUndebounced,
  remove
}
